module.exports = __webpack_public_path__ + "img/faculty-yvette.f88aebd9.png";